// Automatically generated by the `php artisan typescript:transform` command
export type DeductionLabelType = valueof<typeof DEDUCTION_LABEL_TYPES>;
export const DEDUCTION_LABEL_TYPES = {
  DISCOUNT: 'discount',
  CREDIT: 'credit',
} as const;
export interface DefaultGateResource {
  id: number;
  brand: string;
  dependentSelections: Array<ProductSelectionDependentResource>;
}
export interface FlagshipGateResource {
  id: number;
  productId: number;
  brand: string;
  dependentSelections: Array<ProductSelectionDependentResource>;
}
export interface GateGroupResource {
  isMutuallyExclusive: boolean;
  default: GateIdsResource;
  gates: Array<GateIdsResource>;
}
export interface GateIdsResource {
  id: number;
  productId: number;
}
export interface GateSelectionDetailsResource {
  brand: string;
  gateSelectionCategory: string;
  isMutuallyExclusive: boolean;
  isRequired: boolean;
  gateGroups: Array<GateGroupResource>;
}
export interface ItemResource {
  id: number;
  productId: number | null;
  name: string;
  type: ProductItemType;
  category: ProductItemCategory;
  price: number;
  size: ItemSize | null;
  trialVersionId: number | null;
  isPrescription: boolean;
  isTrialOnly: boolean;
  weightInHundredthOz: number | null;
  brands: Array<string>;
}
export type ItemSize = valueof<typeof ITEM_SIZES>;
export const ITEM_SIZES = {
  LARGE: 'large',
  SMALL: 'small',
  SAMPLE: 'sample',
} as const;
export type OfferCategory = valueof<typeof OFFER_CATEGORIES>;
export const OFFER_CATEGORIES = {
  freeTrial: 1,
  v1CurologyTwentyFivePercentOff: 2,
  v1AgencyTwentyFivePercentOff: 3,
  v2AgencyTwentyFivePercentOff: 4,
  v2CurologyFreeOTCProducts: 5,
  v2CurologyTwentyFivePercentOff: 6,
  agencyHigherPriceFreeTrial: 7,
  v3CurologyFreeOTCBundles: 8,
  v3Point1CurologyFreeOTCBundles: 9,
  v4CurologyFreeOTCBundlesV1Ui: 10,
  v4CurologyFreeOTCBundlesV2Ui: 11,
  v5CurologyCheckoutExperienceV1: 12,
  v6CurologyAuthPageBottleImage: 13,
  v6CurologyAuthPageDermatologistImage: 14,
  freeOtcTrial: 15,
  v8CurologyProviderConsultation: 16,
  freeOtcAndFreeDeepCleanseTrial: 17,
} as const;
export type OfferType = valueof<typeof OFFER_TYPES>;
export const OFFER_TYPES = {
  GIVE_20_GET_20: 'give20get20',
} as const;
export type OrderType = valueof<typeof ORDER_TYPES>;
export const ORDER_TYPES = {
  TRIAL: 'trial',
  SUBSCRIPTION: 'subscription',
  FREE: 'free',
  UNKNOWN: 'unknown',
} as const;
export type ProductItemCategory = valueof<typeof PRODUCT_ITEM_CATEGORIES>;
export const PRODUCT_ITEM_CATEGORIES = {
  PRODUCT: 'product',
} as const;
export type ProductItemType = valueof<typeof PRODUCT_ITEM_TYPES>;
export const PRODUCT_ITEM_TYPES = {
  PRESCRIPTION_BOTTLE: 'prescription bottle',
  CLEANSER: 'cleanser',
  MOISTURIZER: 'moisturizer',
  DIGITAL: 'digital',
  HYDROCOLLOID: 'hydrocolloid',
  ACNE_BODY_WASH: 'acne_body_wash',
  FUTURE_FORMULA: 'future_formula',
  DARK_SPOT_FORMULA: 'dark_spot_formula',
  SUNSCREEN: 'sunscreen',
  LIP_BALM: 'lip_balm',
  MAKEUP_REMOVER: 'makeup_remover',
} as const;
export interface ProductOptInResource {
  productId: number;
  displayName: string;
  canOptIn: boolean;
}
export interface ProductResource {
  id: number;
  name: string;
  slug: string;
  brand: string;
  isPrescription: boolean;
  options: Array<string>;
  formulationIds: Array<number>;
  variants: Array<ProductVariantResource>;
  items: Array<Array<ItemResource>>;
  mutuallyExclusiveProductIds: Array<number>;
  isDeferrable: boolean;
}
export type ProductRule = valueof<typeof PRODUCT_RULES>;
export const PRODUCT_RULES = {
  MUTUALLY_EXCLUSIVE_PRODUCTS: 'mutually_exclusive_products',
} as const;
export interface ProductSelectionDependentResource {
  selectableId: number;
  selectableType: string;
}
export interface ProductSetResource {
  id: number;
  name: string;
  brand: string;
  isPrescription: boolean;
  components: Array<ProductResource>;
}
export interface ProductVariantResource {
  id: number;
  name: string;
  slug: string;
  trialVersionId: number | null;
  subscribableVersionId: number | null;
  isInStock: boolean;
  isTrialOnly: boolean;
  optionValues: { [key: string]: string };
  price: number;
  itemId: number;
}
export type UpsellType = valueof<typeof UPSELL_TYPES>;
export const UPSELL_TYPES = {
  MILD_ACNE_MULTI_RX_UPSELL: 'MILD_ACNE_MULTI_RX_UPSELL',
} as const;
